export class ApiError extends Error {
  constructor(public status: number, message: string) {
    super(message);
  }
}

async function request<T>(method: string, path: string, body?: unknown, opts: RequestInit = {}): Promise<T> {
  const init: RequestInit = {
    method,
    credentials: "same-origin",
    headers: { ...(opts.headers || {}) },
    ...opts,
  };
  if (body !== undefined && !(body instanceof FormData)) {
    (init.headers as Record<string, string>)["Content-Type"] = "application/json";
    init.body = JSON.stringify(body);
  } else if (body instanceof FormData) {
    init.body = body;
  }
  const res = await fetch(`/api${path}`, init);
  const isJson = res.headers.get("content-type")?.includes("application/json");
  const payload = isJson ? await res.json().catch(() => null) : await res.text();
  if (!res.ok) {
    const msg = (isJson && payload && (payload as any).error) || `Request failed (${res.status})`;
    throw new ApiError(res.status, msg);
  }
  return payload as T;
}

export const api = {
  get: <T>(p: string) => request<T>("GET", p),
  post: <T>(p: string, b?: unknown) => request<T>("POST", p, b),
  put: <T>(p: string, b?: unknown) => request<T>("PUT", p, b),
  patch: <T>(p: string, b?: unknown) => request<T>("PATCH", p, b),
  del: <T>(p: string, b?: unknown) => request<T>("DELETE", p, b),
  upload: <T>(p: string, form: FormData) => request<T>("POST", p, form),
};
